<template>
    <main id="view-search-machines-results" class="products-results-view">
        <div class="search-title">
            <router-link :to="{path: '/search-machines-filters'}" class="icon-arrow-left"></router-link>
            <span class="text">{{ category.label }}</span>
        </div>
        <div class="filters-container">
            <router-link to="/search-machines-sub-filters" class="button is-primary is-large is-rounded is-uppercase with-small-side-padding subfilter-btn" :class="brandBackgroundColor">
                <span v-html="$t('subfiltering_search_count', { count: activeFiltersCount })"></span>
                <span class="icon-filters is-tiny is-right-side"></span>
            </router-link>
            <transition name="fade">
                <div class="filters-anim-container" v-if="filters.length" :class="{'open' : showFiltersMobile}">
                    <button class="filter-mobile-btn" :class="{'open' : showFiltersMobile}" @click="showHideFilters()">{{ $t("apply_filters") }} <span class="icon-angle-down"></span></button>
                    <transition name="slide">
                        <div class="filters" v-show="showFiltersMobile">
                            <span class="filter" v-for="(filter, index) in filters" :key="filter.attribute" v-if="isDisplayableFilter(filter)">
                                <span class="text">{{ displayCurrentFilter(filter) }}</span>
                                <button class="icon-close delete-filter" @click="deleteFilter(index)"></button>
                            </span>
                            <span class="filter" v-if="range">
                                <span class="text"><span class="filter-label">{{ $t("range") }}</span> : {{ range.label }}</span>
                                <button class="icon-close delete-filter" @click="deleteRangeFilter()"></button>
                            </span>
                        </div>
                    </transition>
                </div>
            </transition>
        </div>

        <div class="results-header" v-if="resultsLoadedFirst">
            <div class="results-count text-desktop" v-if="total > 0">
                {{ $tc('results_count', total) }}
            </div>
            <div class="results-count text-mobile" v-if="total > 0">
              {{ $tc('results_count', total) }}
            </div>
            <div class="no-results" v-else>
                <span class="text">{{ $tc('results_count', 0) }}</span>
                <span class="subtext">{{ $t('please_enlarge_your_filter') }}</span>
            </div>
            <div class="pagination-top">
                <b-pagination
                    v-if="total > itemsPerPage"
                    :total="total"
                    :current.sync="currentPage"
                    order="is-centered"
                    size="is-medium"
                    :simple="isPhone"
                    :per-page="itemsPerPage"
                    rounded v-on:click.native="searchResults()">
                </b-pagination>
            </div>

          <b-select
            v-model="sort"
            @change.native="searchResults"
            size="is-large" rounded

          >
            <option :key="'identifier/1'" :value="'identifier/1'">Aucun tri</option>
            <template
                v-for="attribute in filtersSort"
            >
              <option v-if="attribute.filter_details.type!=='select'" :key="attribute.code+'/1'" :value="attribute.code+'/1'">Tri croissant par {{attribute.label}}</option>
              <option v-if="attribute.filter_details.type!=='select'" :key="attribute.code+'/0'" :value="attribute.code+'/0'">Tri décroissant par {{attribute.label}}</option>
            </template>
          </b-select>

        </div>

        <div class="results" v-if="resultsLoaded && results.length > 0">
            <push-qualify class="result-item" />
            <card-machine
                class="result-item"
                v-for="(result, index) in results"
                :key="result.identifier"
                :style="'order:'+index"
                :datas="result"
                :possible-attributes="[]"
                :class="{'is-bestseller': result.isBestSeller && $store.state.settings.region==='R1' }"
            />
        </div>

        <div class="pagination-bottom" v-if="resultsLoaded">
            <div class="pagination-bottom-right">
                <b-pagination
                    v-if="total > itemsPerPage"
                    :total="total"
                    :current.sync="currentPage"
                    order="is-centered"
                    size="is-medium"
                    :simple="isPhone"
                    :per-page="itemsPerPage"
                    rounded v-on:click.native="searchResults()">
                </b-pagination>
            </div>
        </div>
    </main>
</template>


<script>
    import { mapState, mapGetters } from 'vuex'
    import stickyMixins from "@/common/mixins/sticky";

    import {convertFiltersValuesBackToMetric, triggerTrackingEvent} from "@/common/helpers";

    import productService from '@/services/serli/product'

    import CardMachine from "@/components/Card/CardMachine.vue"
    import PushQualify from "@/components/Push/PushQualify.vue"

    export default {
        name: 'searchMachinesResults',
        mixins: [stickyMixins],
        components: {
            CardMachine,
            PushQualify
        },
        data() {
            return {
                results: [],
                possibleAttribute:[],
                showFiltersMobile: false,
                resultsLoaded: false,
                resultsLoadedFirst: false,
                currentPage: 1,
                total : 0,
                sort: 'identifier/1',
                filtersSort : []
            }
        },
        computed: {
            ...mapState({
                category: state => state.searchMachines.category,
                range: state => state.searchMachines.range,
                filters: state => state.searchMachines.filters,
                isLargeDesktop: state => state.settings.isLargeDesktop,
                isSmallDesktop: state => state.settings.isSmallDesktop,
                isTablet: state => state.settings.isTablet,
                isPhone: state => state.settings.isPhone,
            }),
            ...mapGetters({
                localeKebabFormat: 'settings/localeKebabFormat'
            }),
            itemsPerPage() {
                if(this.isLargeDesktop)
                    return 19
                if(this.isSmallDesktop)
                    return 15
                if(this.isTablet)
                    return 11
                if(this.isPhone)
                    return 10
                return 23;
            },

            activeFiltersCount() {
                let count = 0;
                this.filters.forEach(filter => {
                    if(this.isDisplayableFilter(filter))
                        count++;
                })

                return count;
            }
        },
        created() {
            if (this.$route.query.init){
              this.$store.commit('searchMachines/setCategory', 'machine');
              this.$store.commit('searchMachines/deleteFilters');
            }
            this.loadFilters(this.category.code)
            this.searchResults().then(this.resultsLoadedFirst=true)
        },
        methods:{
            displayCurrentFilter(filter) {
                let filter_datas_displayed = filter.title+' : ';
                if(filter.type === 'slider')
                    filter_datas_displayed += filter.minValue+' - '+filter.maxValue+' '+filter.unit
                if(filter.type === 'select' || filter.type === 'boolean'){
                    filter_datas_displayed += filter.options.find(x => x.code === filter.value).label
                }
                return filter_datas_displayed;
            },
            isDisplayableFilter(filter) {
                return (filter.type !== 'select' || (filter.type === 'select' && filter.value !== ''));
            },
            showHideFilters() {
              this.showFiltersMobile = !this.showFiltersMobile;
            },
            deleteFilter(index) {
                this.$store.commit('searchMachines/deleteFilter', index);
                this.searchResults();
            },
            deleteRangeFilter() {
                this.$store.commit('searchMachines/setRange', null);
                this.searchResults();
            },
            async searchResults() {
                let filters = JSON.parse(JSON.stringify(this.filters));
                filters = await convertFiltersValuesBackToMetric(filters);
                var sort = this.sort.split('/')

                this.resultsLoaded = false;
                this.startLoading();
                productService.list({
                  filters: filters
                }, {
                    productType: 'machines',
                    brand: this.$store.state.settings.brand,
                    category: this.range ? this.range.code : this.category.code,
                    full: false,
                    size: this.itemsPerPage,
                    page : this.currentPage,
                    locale: this.localeKebabFormat,
                    sortAttribute : sort[0],
                    sortAsc:sort[1]
                })
                .then((response) => {
                    if(response.data.code === 200) {
                        this.total = response.data.data.total;
                        this.possibleAttribute = response.data.data.possibleAttributeValues;
                        this.results = response.data.data.results;
                        if(this.new) this.results = response.data;
                        if(this.results.total === 0) {
                            /*gtag('event', 'result_no_machine_found', {
                                'event_category': 'result',
                                'event_label': "Affichage d'une page de résultat de recherche machines vide"
                            });*/

                            triggerTrackingEvent('result_no_machine_found', 'result', "Affichage d'une page de résultat de recherche machines vide")
                        }
                    }
                })
                .finally(() => {
                    this.resultsLoaded = true;
                    this.stopLoading();
                });
            },

          loadFilters(code) {

            productService.filters('machines',code, null, {
              locale: this.localeKebabFormat,
              unit: this.$store.state.settings.unitType
            })
                .then(async response => {
                  if (response.data.code === 200) {
                    const filterDatas = response.data.data.filter(x => {
                      return x.code.search('subcategory') === -1
                    });
                    this.filtersSort = filterDatas;
                  }
                  else
                    this.filtersSort = [];


                });

          },
        }
    }
</script>
